<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4> Exams & results</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard</router-link>
                  \ Exams & results
                </div>
              </div>

            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <div class="col-md-3">
                  <v-select outlined
                      v-model="search.academic_year"
                      dense clearable
                      :items="academicYears"
                      item-text="title"
                      item-value="id"
                      label="Batch">
                  </v-select>
                </div>
                <div class="col-md-2">
                  <v-select outlined
                      :items="programs"
                      v-model="search.program_id"
                      @change="getGrades"
                      dense
                      item-text="title"
                      item-value="id"
                      label="Program">
                  </v-select>

                </div>
                <div class="col-md-2" v-show="search.program_id">
                  <v-select outlined
                      :items="gradesLevels"
                      v-model="search.grade_id"
                      dense
                      item-text="title"
                      item-value="id"
                      label="Semester/year"
                  >
                  </v-select>
                </div>
                <div class="col-md-2">
                  <v-select
                      outlined
                      :items="types"
                      v-model="search.type"
                      dense
                      item-text="text"
                      item-value="value"
                      label="Type"
                  >
                  </v-select>
                </div>
<!--                <div class="col-md-4 my-auto">
                  <v-btn :loading="isBusy" depressed class="btn btn-primary text-white" @click="getExams">Search</v-btn>
                  <v-btn class="btn btn-standard text-white ml-2" @click="reset">Reset</v-btn>
                </div>-->
                <v-col cols="12" md="12" class="text-right">
                  <v-btn
                      @click="getExams()"
                      class="btn btn-primary btn-search "
                      :loading="isBusy"
                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
              </div>
            </div>
            <div class="table-responsive">
              <v-skeleton-loader
                  type="table-thead"
                  v-if="isBusy"
              >
              </v-skeleton-loader>

              <v-skeleton-loader
                  v-if="isBusy"
                  type="table-row-divider@25"
              >
              </v-skeleton-loader>
              <table class="table"   v-if="!isBusy">
                <thead>
                <tr class="px-3">
                  <th>Title</th>
                  <th>Program</th>
                  <th>Exam type</th>
                  <th>Exam date</th>
                  <th>Location</th>
                  <th class="pr-3 text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-show="exams.length > 0" v-for="(exam,index) in exams " :key="index">
                    <td>
                      <span class="font-weight-medium">
                        {{ exam.title }}
                      </span>
                    </td>
                    <td>
                      <div class="text-secondary">
                        <span class="font-weight-black">Grade :</span> {{ exam.grade_title || "N/A" }}
                      </div>
                      <div class="text-secondary">
                        <span class="font-weight-black">Program :</span> {{ exam.program_title || "N/A" }}
                      </div>
                    </td>
                    <td>
                      <v-chip color="green" text-color="white" small>
                        <span class="font-weight-medium">
                          {{ exam.type_text }}
                        </span>
                      </v-chip>
                    </td>
                    <td>
                      <span class="font-weight-medium">
                        {{ exam.start_date | moment("dddd, MMMM Do YYYY") }}
                      </span>
                      <div class="text-secondary" v-if="exam.end_date!=null && exam.end_date!=exam.start_date">
                        <span class="font-weight-black" > to </span>
                      </div>
                        <div class="text-secondary" v-if="exam.end_date!=null && exam.end_date!=exam.start_date">
                        <span class="font-weight-medium" >{{
                            exam.end_date | moment("dddd, MMMM Do YYYY")
                          }}</span>
                      </div>

                    </td>
                    <td>
                      <v-chip color="purple" text-color="white" small>
                        <span class="text-uppercase font-weight-bold">
                          {{ exam.exam_location }}
                        </span>
                      </v-chip>
                    </td>
                    <td class="pr-0 text-center" >
                      <template v-if="(exam.exam_status ==='completed' && exam.is_exam_confirmed) || (exam.is_exam_confirmed)">
                        <b-dropdown
                            size="sm"
                            variant="link"
                            toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                            no-caret
                            right
                            no-flip
                        >
                          <template v-slot:button-content>
                            <i class="ki ki-bold-more-hor"></i>
                          </template>
                          <div class="navi navi-hover min-w-md-250px">
                            <b-dropdown-text tag="div" class="navi-item" v-if="exam.exam_status ==='completed' && exam.is_exam_confirmed">
                              <a @click="manageResult(exam)" class="navi-link">
                                <span class="navi-icon">
                                  <i class="fas fa-edit"></i>
                                </span>
                                <span class="navi-text"> Manage result</span>
                              </a>
                            </b-dropdown-text>
                            <b-dropdown-text tag="div" class="navi-item" v-if="exam.is_exam_confirmed">
                              <a @click="viewTimeTable(item)" class="navi-link">
                                <span class="navi-icon">
                                  <i class="fas fa-eye"></i>
                                </span>
                                <span class="navi-text">View</span>
                              </a>
                            </b-dropdown-text>
                            <b-dropdown-text tag="div" class="navi-item" v-if="exam.is_exam_confirmed">
                              <a @click="download(exam.slug)" class="navi-link">
                                <span class="navi-icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                <span class="navi-text">PDF</span>
                              </a>
                            </b-dropdown-text>
                          </div>
                        </b-dropdown>
                      </template>
                      <span class="font-weight-medium" v-else>
                        Action not available.
                      </span>
                    </td>
                  </tr>
                  <tr v-if="exams.length==0">
                    <td colspan="6" class="text-center">
                      <strong>No items added.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <b-pagination
                  v-if="exams.length > 0"
                  class="pull-right mt-7"
                  @input="getAcademicYears"
                  v-model="page"
                  :total-rows="total"
                  :per-page="perPage"
                  first-number
                  last-number
              ></b-pagination>
            </div>

          </div>
        </div>
      </div>
    </div>


<!--    <div v-if="!isBusy && exams && exams.length>0">
      <div class="row mt-5">
        <div class="col-xl-3 col-md-3 col-sm-12" v-for="(exam) in exams " :key="exam">
          <v-card class="mx-auto" style="min-height: 390px" flat>
            <template slot="progress">
              <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
            </template>
            <v-img height="100"
                   src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3578&q=80"></v-img>
            <v-card-title class="mb-0"> {{ exam.title }}</v-card-title>
            <v-card-subtitle>
              {{ exam.grade_title || "N/A" }}<br>
              {{ exam.program_title || "N/A" }}<br>
              <b>{{ exam.start_date | moment("dddd, MMMM Do YYYY") }}</b>
              <span v-if="exam.end_date!=null && exam.end_date!=exam.start_date"> to </span>
              <b v-if="exam.end_date!=null && exam.end_date!=exam.start_date">{{
                  exam.end_date | moment("dddd, MMMM Do YYYY")
                }}</b>
              <p class="mt-1">
                <i class="fas fa-clock"></i>
                {{ `${exam.duration ? exam.duration : ''} ${exam.duration_unit ? exam.duration_unit : ''}` }}
              </p>
              <div class="d-flex flex justify-content-start ">
                <v-chip color="green" text-color="white" small><strong class="text-uppercase">{{ exam.type }}</strong>
                </v-chip>
                <v-chip color="purple" text-color="white" small class="ml-2"><strong class="text-uppercase">
                  {{ exam.exam_location }}</strong></v-chip>
              </div>
              <div class="d-flex flex justify-content-start mt-2"
                   v-if="exam.exam_status ==='completed' && exam.is_exam_confirmed">
                <v-chip color="blue" text-color="white" small class="">
                  <router-link class="text-white "
                               :to="{ name:'exam-summary',params:{exam_id:exam.id}}">
                    <strong class="text-uppercase"> Manage Result </strong>
                  </router-link>
                </v-chip>
              </div>
            </v-card-subtitle>

            <v-card-text>
              <div class=" text-subtitle-1">
                &lt;!&ndash;                               <v-btn class="btn btn-primary text-white">Admit Card</v-btn>&ndash;&gt;
                &lt;!&ndash;                <v-divider class="mx-4" v-if="exam.is_exam_confirmed"></v-divider>&ndash;&gt;
                <v-chip v-if="exam.is_exam_confirmed" color="info" text-color="white" small
                        @click="viewTimeTable(exam)">
                  <i class="far fa-file-pdf mr-2 text-white"></i> <strong class="text-uppercase"> View </strong>
                </v-chip>

                <v-chip v-if="exam.is_exam_confirmed" color="black" text-color="white" small class="ml-2">
                  <i class="fas fa-download mr-2 text-white"></i> <a
                    @click.prevent="download(exam.slug)"> <strong class="text-uppercase"> PDF </strong></a></v-chip>


              </div>
            </v-card-text>

          </v-card>
        </div>
        &lt;!&ndash;          <div class="col-xl-3 col-md-3 col-sm-12" v-for="(exam) in exams " :key="exam">&ndash;&gt;
        &lt;!&ndash;            <v-card class="mx-auto" style="min-height: 320px" flat>&ndash;&gt;
        &lt;!&ndash;              <template slot="progress">&ndash;&gt;
        &lt;!&ndash;                <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>&ndash;&gt;
        &lt;!&ndash;              </template>&ndash;&gt;
        &lt;!&ndash;              <v-img height="100"&ndash;&gt;
        &lt;!&ndash;                     src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3578&q=80"></v-img>&ndash;&gt;
        &lt;!&ndash;              <v-card-title class="mb-0"> {{exam.title}}</v-card-title>&ndash;&gt;
        &lt;!&ndash;              <v-card-subtitle>&ndash;&gt;
        &lt;!&ndash;                <b>{{exam.start_date | moment("dddd, MMMM Do YYYY") }}</b>&ndash;&gt;
        &lt;!&ndash;                <span v-if="exam.end_date!=null"> to </span>&ndash;&gt;
        &lt;!&ndash;                <b>{{exam.end_date | moment("dddd, MMMM Do YYYY") }}</b>&ndash;&gt;
        &lt;!&ndash;                <p class="mt-1">&ndash;&gt;
        &lt;!&ndash;                  <i class="fas fa-clock"></i>&ndash;&gt;
        &lt;!&ndash;                  {{`${exam.duration} ${exam.duration_unit}`}}&ndash;&gt;
        &lt;!&ndash;                </p>&ndash;&gt;
        &lt;!&ndash;                <div class="d-flex flex justify-content-start ">&ndash;&gt;
        &lt;!&ndash;                  <v-chip color="green" text-color="white" small><strong class="text-uppercase">{{exam.type}}</strong></v-chip>&ndash;&gt;
        &lt;!&ndash;                  <v-chip color="purple" text-color="white" small class="ml-2"><strong class="text-uppercase"> {{exam.exam_location}}</strong></v-chip>&ndash;&gt;
        &lt;!&ndash;                  <v-chip v-if="exam.result_status ==='published' && exam.is_exam_confirmed" color="blue" text-color="white" small class="ml-2">&ndash;&gt;
        &lt;!&ndash;                    <router-link class="text-white "&ndash;&gt;
        &lt;!&ndash;                                 :to="{ name:'exams-summary',params:{exam_id:exam.id}}">&ndash;&gt;
        &lt;!&ndash;                      <strong class="text-uppercase"> Manage Result </strong>&ndash;&gt;
        &lt;!&ndash;                    </router-link>&ndash;&gt;
        &lt;!&ndash;                  </v-chip>&ndash;&gt;
        &lt;!&ndash;                </div>&ndash;&gt;
        &lt;!&ndash;              </v-card-subtitle>&ndash;&gt;

        &lt;!&ndash;              <v-card-text>&ndash;&gt;
        &lt;!&ndash;                <div class=" text-subtitle-1">&ndash;&gt;
        &lt;!&ndash;                  <b>Grade:</b> {{ exam.grade_title || "N/A" }}<br>&ndash;&gt;
        &lt;!&ndash;                  <b>Program:</b> {{exam.program_title || "N/A" }}<br>&ndash;&gt;

        &lt;!&ndash;                  &lt;!&ndash;                               <v-btn class="btn btn-primary text-white">Admit Card</v-btn>&ndash;&gt;&ndash;&gt;
        &lt;!&ndash;                  <v-divider class="mx-4" v-if="exam.is_exam_confirmed"></v-divider>&ndash;&gt;
        &lt;!&ndash;                  <v-chip v-if="exam.is_exam_confirmed" color="info" text-color="white" small @click="viewTimeTable(exam)">&ndash;&gt;
        &lt;!&ndash;                    <i class="far fa-file-pdf mr-2 text-white"></i> View TimeTable&ndash;&gt;
        &lt;!&ndash;                  </v-chip>&ndash;&gt;

        &lt;!&ndash;                  <v-chip v-if="exam.is_exam_confirmed" color="info" text-color="white" small class="ml-2">&ndash;&gt;
        &lt;!&ndash;                    <i class="fas fa-download mr-2 text-white"></i> <a&ndash;&gt;
        &lt;!&ndash;                      @click.prevent="download(exam.slug)"> Download </a></v-chip>&ndash;&gt;


        &lt;!&ndash;                </div>&ndash;&gt;
        &lt;!&ndash;              </v-card-text>&ndash;&gt;

        &lt;!&ndash;            </v-card>&ndash;&gt;
        &lt;!&ndash;          </div>&ndash;&gt;
        <div class="col-12 text-right" v-if="exams.length>0">
          <b-pagination
              @input="getAcademicYears"
              v-model="page"
              :total-rows="total"
              :per-page="perPage"
              first-number
              last-number
          ></b-pagination>
          &lt;!&ndash;  &ndash;&gt;
        </div>
      </div>

      &lt;!&ndash;      <create-and-update ref="exam" @refresh="getExams"></create-and-update>&ndash;&gt;
      &lt;!&ndash;      <assign-courses ref="assignCourse" @refresh="getExams"></assign-courses>&ndash;&gt;
      &lt;!&ndash;      <courses-timetable ref="courseTimetable" @refresh="getExams"></courses-timetable>&ndash;&gt;
    </div>-->


    <v-dialog v-model="timeTableDialog" max-width="800">
      <v-card v-if="selectedExam">
        <v-card-title>
          {{ selectedExam.title }} Time Table
        </v-card-title>
        <v-card-text>
          <div class="table-responsive" v-if="selectedExam.courses.length">
            <table class="table table-stripe">
              <thead>
              <th>Title</th>
              <th>Start Date</th>
              <th>Start Time</th>
              <th>End Date</th>
              <th>End Time</th>
              </thead>
              <tbody>
              <tr v-for="(course,index) in selectedExam.courses" :key="index">
                <td>
                  {{ course.course_title }}

                </td>
                <td>
                  <div>{{ course.start_date | moment("MMMM Do YYYY") }} <br>

                  </div>
                </td>
                <td>
                  <strong v-if="course.start_time"> {{ course.start_time }}</strong>

                </td>
                <td>
                  <div>{{ course.end_date | moment(" MMMM Do YYYY") }} <br>
                  </div>
                </td>
                <td>
                  <strong v-if="course.end_time"> {{ course.end_time }}</strong>

                </td>
              </tr>
              </tbody>
            </table>
          </div>


        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>

</template>

<script>
import CreateAndUpdate from "./CreateAndUpdate";
import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
import ExamService from "@/core/services/exam/ExamService";
import AssignCourses from "./AssignCourses";
import ProgramService from "@/core/services/level/program/ProgramService";
import AcademicYearService from "@/core/services/academicYear/AcademicYearService";
import GradeLevelService from "@/core/services/gradeLevel/GradeLevelService";
import ConfigService from "../../../core/services/config/ConfigService";


const examService = new ExamService();
const academicClassService = new AcademicClassService();
const programService = new ProgramService();
const academicYearService = new AcademicYearService();
const gradeLevelService = new GradeLevelService();
const configService = new ConfigService();
import {API_URL} from '@/common/config.js';
import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";

export default {
  name: "academic-class",
  mixins:[SiteSettingMixin],
  components: {
    CreateAndUpdate,
    AssignCourses
  },
  data() {
    return {
      dialog: false,
      isLoading: false,
      isBusy: false,
      examId: null,
      excel_file: null,
      academic_classes: [],
      timeTableDialog: false,
      exams: [],
      search: {
        academic_year: "",
        program_id: "",
        grade_id: "",
        type: "",
        markObtain: "",
      },
      academicYears: [],
      programs: [],
      gradesLevels: [],
      types: [
        {
          text: 'Terminal',
          value: 'terminal',
        },
        {
          text: 'Class Test',
          value: 'class_test',
        },
        {
          text: 'Board',
          value: 'board',
        },
      ],
      academic_id: null,
      selectedExam: null,
      page: null,
      total: null,
      perPage: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
  },
  mounted() {
    if(this.checkTeacherMenuAccess('exam_and_results')==false ){
      this.$router.push({name: '404'})
    }
    // this.getAcademicClasses();
    this.getExams();
    this.getAcademicYears();
    this.getPrograms();

  },
  methods: {
    isAccessible(roles) {
      let flag = [];
      let type = this.currentUser.type;
      let userRoles = configService.getRoles(type);
      roles = roles.split(",");
      for (let t of roles) {
        t = t.trim();
        if (userRoles.includes(t)) {
          flag.push(true);
        } else {
          flag.push(false);
        }
      }
      if (flag.includes(true)) {
        return true;
      } else return false;
    },
    download(slug) {
      let url = API_URL + "timetable-pdf"
      url = url + "?exam=" + slug
      // console.log(url)
      window.open(url)
      return;
    },
    viewTimeTable(exam) {
      this.timeTableDialog = true;
      this.selectedExam = exam;
    },
    getGrades() {
      gradeLevelService.getByProgram(this.search.program_id).then(response => {
        this.gradesLevels = response.data;
      });
    },
    calculateTotal(exam) {
      exam.calculate_total = 1;
      examService.update(exam.id, exam).then(response => {
        this.$snotify.success("Total calculation has been scheduled.");
        this.getExam();
      });
    },
    getPrograms() {
      programService.all().then(response => {
        this.programs = response.data;
      });
    },
    getAcademicYears() {
      academicYearService.paginate().then(response => {
        this.academicYears = response.data.data;

      });
    },
    reset() {
      this.search = {
        academic_year: "",
        program_id: "",
        grade_id: "",
        type: "",
        markObtain: "",
      }
      this.getExams();
    },
    getAcademicClasses() {
      academicClassService.paginate().then(response => {
        this.exams = response.data.data;
        this.page = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.perPage = response.data.meta.per_page;
      });
    },
    getExams() {
      this.isBusy = true;
      // this.$bus.emit('toggleLoader');
      examService.paginate(this.search).then(response => {
        this.exams = response.data.data;
        // console.log(this.exams)
        this.page = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.perPage = response.data.meta.per_page;
      }).catch((err) => {
        // console.log(err)
      }).finally(() => {
        this.isBusy = false;
        // this.$bus.emit('toggleLoader');
      });
    },
    openDialog(exam) {
      this.$refs["exam"].showModal(exam);
    },
    assignCourse(exam) {
      this.$refs["assignCourse"].showModal(exam);
    },

    markAs(id, type) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            examService.markAs(id, type).then(response => {
              this.$snotify.success("Updated successfully");
              this.getExams();
            });
          }
        }
      });
    },

    deleteAcademicYear(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            academicClassService.delete(id).then(response => {
              this.$snotify.success("Deleted successfully");
              this.getAcademicClasses();
            });
          }
        }
      });
    }, openImportResult(id) {
      this.dialog = true
      this.examId = id;

    }, importResult() {
      this.isLoading = true
      let fd = new FormData();
      fd.append("file", this.excel_file);
      examService.importResult(this.examId, fd).then(response => {
        this.isLoading = false
        this.excel_file = null;
        this.$snotify.success("Imported Successfully")
        this.examId = null;
        this.dialog = false
        this.getExams();
      })
    }, notifyStudents(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            examService.notifyStudents(id).then(response => {
              this.$snotify.success("Scheduled successfully")
            })
          }
        }
      });
    },
    downloadLedger(examId) {
      window.open(
          API_URL + "download/exam/ledger/" + examId,
          "_blank"
      );
    },
    manageResult(item){
      this.$router.push(
          {
            name: 'exam-summary',
            params: {exam_id: item.id}
          }
      )
    }
  }
};
</script>

<style scoped>

</style>
